const NEXT_KEYS: ReadonlySet<string> = new Set(['ArrowRight', 'ArrowDown']);
const PREVIOUS_KEYS: ReadonlySet<string> = new Set(['ArrowLeft', 'ArrowUp']);

/**
 * The radio an arrow key moves a radiogroup to, wrapping at both ends; null for any other key, which
 * the group must leave to the browser.
 */
export function nextRadioIndex(key: string, index: number, count: number): number | null {
  const step = NEXT_KEYS.has(key) ? 1 : PREVIOUS_KEYS.has(key) ? -1 : 0;
  return step === 0 ? null : (index + step + count) % count;
}
